// extracted by mini-css-extract-plugin
export default {"hideTooltip":"eda-z","fadeIn":"fda-z","delay":"gda-z","recommendedSizeTooltip":"hda-z"};